import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as actions from '../actions/dashboard.actions';
import {
  DashboardState,
  initialDashboardState,
} from '../state/dashboard.state';

export const dashboardFeatureStoreKey: string = 'dashboardState';

export const reducers = (
  state: DashboardState,
  action: Action,
): DashboardState => {
  return initReducer(state, action);
};

export const initReducer = createReducer(
  initialDashboardState,
  on(actions.getSearchContacts, (state, { searchedContact }) => ({
    ...state,
    searchedContact,
  })),
  on(actions.getSearchContactsSuccess, (state, { searchedContacts }) => ({
    ...state,
    searchedContacts,
  })),
  on(actions.getSearchContactsError, (state) => ({ ...state })),
  on(actions.resetSearchedContacts, (state) => ({
    ...state,
    searchedContacts: [],
  })),
  on(actions.addChosenContact, (state) => ({
    ...state,
    isAddContactProcessing: true,
  })),
  on(actions.addChosenContactSuccess, (state) => ({
    ...state,
    isAddContactProcessing: false,
    searchedContacts: [],
    searchedContact: null,
  })),
  on(actions.addChosenContactError, (state) => ({
    ...state,
    isAddContactProcessing: false,
  })),
  on(actions.inviteChosenContact, (state) => ({
    ...state,
    isInviteContactSending: true,
  })),
  on(actions.inviteChosenContactSuccess, (state) => ({
    ...state,
    isInviteContactSending: false,
    searchedContact: null,
  })),
  on(actions.inviteChosenContactError, (state) => ({
    ...state,
    isInviteContactSending: false,
  })),
  on(actions.getBalancesOverview, (state) => ({ ...state })),
  on(actions.getBalancesOverviewSuccess, (state, { balancesOverview }) => ({
    ...state,
    balancesOverview,
  })),
  on(actions.getBalancesOverviewError, (state) => ({ ...state })),
  on(actions.getRecentTransactions, (state) => ({
    ...state,
    isRecentTransactionsLoading: true,
    recentTransactionsError: false,
  })),
  on(actions.getRecentTransactionsSuccess, (state, { response }) => ({
    ...state,
    recentTransactionActivities: response.activities,
    isRecentTransactionsLoading: false,
  })),
  on(actions.getRecentTransactionsError, (state) => ({
    ...state,
    isRecentTransactionsLoading: false,
    recentTransactionsError: true,
  })),
);

export const dashboardFeature = createFeature({
  name: dashboardFeatureStoreKey,
  reducer: reducers,
});
